<div class="inner-content" *ngIf="showHeader">
  <div class="profile-skeleton-card">
    <div class="profile-skeleton-banner">
      <app-skeleton className="h-100% w-100% r-16 md:h-230"></app-skeleton>
    </div>
    <div class="profile-skeleton-card-content">
      <div class="profile-skeleton-user">
        <div class="profile-skeleton-user-header">
          <div class="profile-skeleton-user-main">
            <app-skeleton className="h-60 w-60 md:h-86 md:w-86 r-50%"></app-skeleton>
            <div class="profile-skeleton-user-info">
              <app-skeleton className="h-22 w-180 r-8"></app-skeleton>
              <app-skeleton className="h-16 w-140 r-8" extraClassName="mt-2"></app-skeleton>
            </div>
          </div>
          <div class="profile-skeleton-user-header-share">
            <app-skeleton className="h-35 w-35 md:h-40 md:w-40 r-50%"></app-skeleton>
          </div>
        </div>
      </div>
      <div class="profile-skeleton-top-buttons">
        <app-skeleton className="h-40 w-80 r-20"></app-skeleton>
        <app-skeleton className="h-40 w-80 r-20"></app-skeleton>
        <app-skeleton className="h-40 w-80 r-20"></app-skeleton>
        <app-skeleton className="h-40 w-80 r-20"></app-skeleton>
      </div>
    </div>
  </div>

  <ng-container *ngIf="showPosts">
    <ng-container *ngTemplateOutlet="postSkeletons"></ng-container>
  </ng-container>
</div>

<ng-container *ngIf="showPosts && !showHeader">
  <ng-container *ngTemplateOutlet="postSkeletons"></ng-container>
</ng-container>

<ng-template #postSkeletons>
  <div *ngFor="let _ of postIndices" class="profile-skeleton-post">
    <div class="profile-skeleton-post-header">
      <div class="profile-skeleton-post-author">
        <app-skeleton className="h-48 w-48 r-50%"></app-skeleton>
        <div class="profile-skeleton-post-author-text">
          <app-skeleton className="h-16 w-110 r-8"></app-skeleton>
          <app-skeleton className="h-12 w-80 r-8" extraClassName="mt-2"></app-skeleton>
        </div>
      </div>
      <div class="profile-skeleton-post-actions">
        <app-skeleton className="h-28 w-56 r-14"></app-skeleton>
        <app-skeleton className="h-28 w-28 r-50%"></app-skeleton>
        <app-skeleton className="h-28 w-28 r-50%"></app-skeleton>
      </div>
    </div>
    <div class="profile-skeleton-post-lines">
      <app-skeleton className="h-14 w-100% r-6"></app-skeleton>
      <app-skeleton className="h-14 w-95% r-6" extraClassName="mt-2"></app-skeleton>
      <app-skeleton className="h-14 w-90% r-6" extraClassName="mt-2"></app-skeleton>
    </div>
    <app-skeleton className="h-320 w-100% r-10" extraClassName="mt-3"></app-skeleton>
    <div class="profile-skeleton-post-footer">
      <div class="profile-skeleton-post-footer-item">
        <app-skeleton className="h-16 w-16 r-50% c-bgt"></app-skeleton>
        <app-skeleton className="h-16 w-84 r-8 c-bgt"></app-skeleton>
      </div>
      <div class="profile-skeleton-post-footer-item">
        <app-skeleton className="h-16 w-16 r-50% c-bgt"></app-skeleton>
        <app-skeleton className="h-16 w-84 r-8 c-bgt"></app-skeleton>
      </div>
      <div class="profile-skeleton-post-footer-item">
        <app-skeleton className="h-16 w-16 r-50% c-bgt"></app-skeleton>
        <app-skeleton className="h-16 w-84 r-8 c-bgt"></app-skeleton>
      </div>
    </div>
  </div>
</ng-template>

<div *ngIf="showSidebar" class="profile-skeleton-sidebar">
  <app-skeleton
    *ngFor="let _ of sidebarCardIndices"
    className="h-100 w-100% r-12 c-post"
  ></app-skeleton>
  <div *ngIf="showViewAllButtonSkeleton" class="profile-skeleton-sidebar__view-all">
    <app-skeleton className="h-40 w-100% r-24 c-post"></app-skeleton>
  </div>
  <div *ngIf="showAdSkeleton" class="profile-skeleton-sidebar__ad">
    <app-skeleton className="h-500 w-100% r-20 c-post"></app-skeleton>
  </div>
</div>
